<template>
  <div>
    <h3 class="fn-lg blue text-center spacing top md">請同意成為神腦生活會員</h3>
    <div class="border bottom spacing bottom md"></div>
    <h4 class="text-center spacing bottom sm">系統將以您提供的手機號碼</h4>
    <h4 class="text-center spacing top sm bottom sm value fn-lg">{{ mobilePhone }}</h4>
    <h4 class="text-center spacing bottom lg">註冊成為神腦會員</h4>
    <div class="border bottom"></div>
    <register-info :isMobile="true" :name-err-msg="'姓名'" :email-err-msg="'E-Mail'" :sex-err-msg="'性別'" />
    <div class="mb-privacy-block">
      <div class="mb-privacy-modal">
        <div class="head-ex">神腦生活會員服務條款及隱私權政策</div>
        <privacy-terms-content :isMobile="true" @marketing-changed="handleMarketingOptionsChange" />
      </div>
    </div>
    <div class="divider">
      <label for="checkAgreeTerms">
        <input type="checkbox" id="checkAgreeTerms" name="同意條款" v-validate="'required'" required />
        我已詳讀並同意會員條款及隱私權條款
        <p class="error" v-if="errors.has('同意條款')">請勾選同意條款</p>
      </label>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-disabled btn-round" data-dismiss="modal" @click="$emit('cancel')">
        不同意
      </button>
      <button
        type="button"
        class="btn btn-primary btn-round"
        href="javascript:void(0);"
        @click="verifyAndGetMemberRegistration">
        同意
      </button>
    </div>
  </div>
</template>

<script>
import { inject } from 'vue';
import { createRegistrationItem, sendGA4sEvent } from '@/helpers/tracking/ga';
import { useRegister } from '@/composables/register';
import { commitMutation } from '@/helpers/vuex';
import PrivacyTermsContent from '@/components/common/modals/register-info-modal/privacy-terms-content.vue';
import RegisterInfo from '@/components/common/modals/register-info-modal/register-info.vue';

export default {
  name: 'step1-member-registration',
  inject: ['$validator'],
  props: {
    mobilePhone: {
      type: String,
      default: '',
    },
  },
  components: {
    PrivacyTermsContent,
    RegisterInfo,
  },
  setup(props, context) {
    const $validator = inject('$validator');
    const { fetchRegister, focusErrorInput } = useRegister(props, context);

    /**
     * step1 表單驗證並獲取會員註冊資料
     */
    const verifyAndGetMemberRegistration = () => {
      $validator.validateAll().then((isVerifyResultSuccess) => {
        if (!isVerifyResultSuccess) {
          focusErrorInput($validator.errors);
          return;
        }
        sendGA4sEvent('sign_up_join', createRegistrationItem('註冊資料填寫完成', 'cart'));
        fetchRegister();
      });
    };

    const handleMarketingOptionsChange = (options) => {
      const getMarketingPreferences = options.reduce((acc, item) => {
        acc[item.flag] = '1';
        return acc;
      }, {});
      commitMutation('OrderInfo', 'marketingOptions', getMarketingPreferences);
    };

    return {
      fetchRegister,
      verifyAndGetMemberRegistration,
      handleMarketingOptionsChange,
    };
  },
};
</script>
